import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CustomerLogos } from '../components/CustomerLogos';
import { FeaturesSection } from '../components/FeaturesSection';
import { VCLogos } from '../components/VCLogos';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-398" />
      <CustomerLogos data-id="element-399" />
      <FeaturesSection data-id="element-400" />
      <VCLogos data-id="element-401" />
      <CTABanner data-id="element-402" />
    </>;
}